<template>
	<nk-page commercialAccess="Salary" policyClaims="Salary_SalaryPeriod_Management" tabindex="100" startup>
		<div class="nk-card h-100 d-flex flex-column " ref="parent">
			<div class="d-flex pr-5 pt-2">
				<div class="col-sm-6 col-md-6 col-lg-4">
					<nk-col-form-group :label="$t('salary.filter-salary-period') + ' :'" :labelSizes="{ sm: 12, md: 3 }" :dataSizes="{ sm: 12, md: 9 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<!--						<nk-dropdown-center  @update:modelValue="monthFilterChanged" v-model=" localData.selectedFilterMonth" :options="filterMonthOptions" tabindex="102"></nk-dropdown-center>-->
						<nk-dropdown class="form-container" :options="filterOptions.month" :model-value="filterValue.month" :tabindex="102" :data="filterMonthData" @update:modelValue="(data: ILock) => filterChanged('month', data)"></nk-dropdown>

					</nk-col-form-group>
				</div>
				<div class="col-sm-6 col-md-6 col-lg-4 align-content-start">
					<div class="d-inline-flex ">
						<div class="d-flex px-1">
							<label class="pl-2">{{ $t('salary.primary') }}</label>
							<nk-checkbox type="checkbox" :checked="filterValue.primary" @update:modelValue="(data: boolean | string) => filterChanged('primary', data)" :tabindex="104" />
						</div>
						<div class="d-flex px-1">
							<label class="pl-2">{{ $t('salary.virtual') }}</label>
							<nk-checkbox type="checkbox" :checked="filterValue.virtual" @update:modelValue="(data: boolean | string) => filterChanged('virtual', data)" :tabindex="106" />
						</div>
					</div>
				</div>
			</div>
			<div class=" flex-grow-1 overflow-auto">
				<div v-for="period of filterExistingPeriods" :key="period.pMonthName + period.subPeriods.length" class="pt-3 ">
					<div class="d-inline-flex  align-items-center">
						<div class="ml-2">
							<div class="rotate bgPrimary-light-fade text-dark text-extra-bold">{{ period.pMonthName }}</div>
						</div>
						<month-period-card :isModal="isModal" :data="period.filteredSubPeriods" @update:modelValue="(subPeriod: SubPeriod) => changeSelectedPeriod(subPeriod)" @reset-periods="getPeriods" :options="{ ...monthPeriodCardOptions, period, insertPeriodFunc: (subPeriod: SubPeriod) => insertPeriod(period, subPeriod), isModal }"></month-period-card>
						<div v-show="!isModal" class="rotate mr-2 cursor-pointer apposite-reduce bgPrimary-light-fade text-extra-bold" @click="() => insertPeriod(period)">
							<i class="fa-solid fa-plus"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>

<script lang="ts">
	import smallCheckbox from '@/components/general/small-checkbox.vue'
	import monthPeriodCard from '@/views/salary/salary-period/period-card.vue'
	import jalaliMoment from 'jalali-moment'
	import { mapActions, mapGetters } from 'vuex'
	import createPeriod from '@/views/salary/salary-period/salary-period-modify.vue'
	import { defineComponent } from 'vue'
	import { ConvertedSalaryPeriod, IStringMap, MonthPeriodCardOptions, SalaryPeriod, SubPeriod } from '@/classes/salary/salary-period'
	import cloneDeep from 'lodash/cloneDeep'

	interface ILock {
		isLocked: boolean,
		name: string
	}

	export default defineComponent({
		name: "month-selector",
		emits: ['update:modelValue'],
		props: {
			modelValue: Object,
			data: Array,
			options: Object
		},
		components: {
			smallCheckbox,
			monthPeriodCard
		},
		mounted() {
			this.currentSalaryPeriodObj = this.getSalaryPeriod
			// this.manipulatePeriodData()
			this.prepareWindow(this.$t('salary.select-salary-period'),)
			this.getPeriods()

			this.defer(() => {
				document.querySelector('.borderPrimary-light')?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
			}, 1)
		},
		data() {
			return {
				monthPeriodCardOptions: {
					title: '',
				} as MonthPeriodCardOptions,
				periodItems: {} as IStringMap<SubPeriod[]>,
				currentSalaryPeriodObj: null as SalaryPeriod | null,
				filterOptions: {
					month: {}
				},
				filterValue: {
					month: null,
					primary: true,
					virtual: true
				} as any,
				filterMonthData: [
					{ isLocked: true, name: this.$t('salary.period.locked-periods') },
					{ isLocked: false, name: this.$t('salary.period.opened-periods') },
				] as ILock[],
				existingPeriods: [] as ConvertedSalaryPeriod[],
				filterExistingPeriods: [] as ConvertedSalaryPeriod[],
			}
		},
		computed: {
			...mapGetters({
				getFiscalPeriod: 'appContext/getFiscalPeriod',
				getSalaryPeriod: 'appContext/getSalaryPeriod',
				getAllPeriods: 'salaryPeriods/all'
			}),
			isModal() {
				return this.grandParentType() === 'modal'
			}
		},
		methods: {
			...mapActions({
				setSalaryPeriod: 'appContext/setSalaryPeriod'
			}),
			manipulatePeriodData() {
				this.existingPeriods = []
				const currentFiscalPeriod = this.getFiscalPeriod
				const jalaliDateConverter = (date: string) => jalaliMoment(date, 'YYYY/MM/DD').locale('fa')
				const miladyDateConverter = (date: jalaliMoment.Moment) => jalaliMoment.from(date.format('YYYY/MM/DD'), 'fa')
				const startDate = jalaliDateConverter(currentFiscalPeriod.startDate).startOf('month')
				const endDate = jalaliDateConverter(currentFiscalPeriod.endDate)
				const diffMonth = endDate.diff(startDate, 'month')
				for (let i = -1; i < diffMonth; i++) {
					if (i === 0) startDate.startOf('jMonth')
					startDate.add(i < 0 ? 0 : 1, 'month')
					const convSalaryPeriod: ConvertedSalaryPeriod = Object.assign(new ConvertedSalaryPeriod(), { pMonthName: startDate.format('MMMM'), pYear: startDate.format('YYYY'), pMonth: startDate.format('MM'), date: miladyDateConverter(startDate).format('YYYY-MM-DDT00:00:00'), year: miladyDateConverter(startDate).format('YYYY'), month: miladyDateConverter(startDate).format('M') })
					if (this.periodItems[convSalaryPeriod.date]) {
						convSalaryPeriod.subPeriods = this.periodItems[convSalaryPeriod.date]
						convSalaryPeriod.filteredSubPeriods = this.periodItems[convSalaryPeriod.date]
					}
					this.existingPeriods.push(convSalaryPeriod)
				}
				this.filterExistingPeriods = []
				this.filterExistingPeriods = this.existingPeriods
				return this.filterExistingPeriods
			},
			getPeriods() {
				this.periodItems = cloneDeep(this.getAllPeriods).reduce((a: any, c: SubPeriod) => {
					if (c.id === this.currentSalaryPeriodObj?.id) c.selected = true
					if (!a[c.date]) a[c.date] = [c]
					else a[c.date].push(c)
					return a
				}, {})
				return this.manipulatePeriodData()
			},
			insertPeriod(period: ConvertedSalaryPeriod, subPeriod: SubPeriod = new SubPeriod()) {
				//@ts-ignore
				this.showModal({ component: createPeriod, options: { getMonths: this.getPeriods, selectedMonth: period, subPeriod: subPeriod } }).then(() => {
					this.getPeriods()
				}).catch(() => { })
					.finally(() => this.getPeriods())
			},
			changeSelectedPeriod(period: SubPeriod) {
				let lastActivePeriod: SubPeriod | null = this.existingPeriods.reduce((a: SubPeriod | null, c: ConvertedSalaryPeriod) => {
					const foundPeriod = c.subPeriods.find(x => x.selected)
					if (foundPeriod) a = foundPeriod
					return a
				}, null)
				if (lastActivePeriod?.id !== period?.id) {
					this.existingPeriods.forEach((c: ConvertedSalaryPeriod) => {
						const foundNewPeriod = c.subPeriods.find(x => x.id === period.id)
						if (foundNewPeriod) {
							if (this.options?.type === 'selector') {
								foundNewPeriod.selected = true
								lastActivePeriod && (lastActivePeriod.selected = false)
								this.$emit('update:modelValue', { id: foundNewPeriod.id, date: c.date, year: c.year, month: c.month })
							}
						}
					})
					this.filterExistingPeriods = this.existingPeriods
					this.calcFilter()
				}
			},
			calcFilter() {
				this.filterExistingPeriods = this.existingPeriods.filter((x: ConvertedSalaryPeriod) => {
					x.filteredSubPeriods = x.subPeriods.filter(y => {
						let filterState = true
						if (this.filterValue.month) filterState = this.filterValue.month.isLocked === y.isLocked
						if (filterState && !this.filterValue.virtual && this.filterValue.primary) filterState = y.isMain
						else if (filterState && this.filterValue.virtual && !this.filterValue.primary) filterState = y.isMain === false
						else if (filterState && !this.filterValue.virtual && !this.filterValue.primary) filterState = false
						return filterState
					})
					// if (x.filteredSubPeriods.length) return true
					// else return false
					return true
				})
			},
			filterChanged(type: string, data: any) {
				this.filterValue[type] = data
				this.calcFilter()
			}
		}
	})
</script>

<style scoped>
	.rotate {
		writing-mode: vertical-lr;
		-webkit-transform: rotate(180deg);
		-moz-transform: rotate(180deg);
		height: 80px;
		text-align: center;
		width: 50px;
		border-radius: 6px 0px 0px 6px;
		padding-left: 15px;

		&:is(.apposite-reduce) {
			border-radius: 0px 6px 6px 0px;
		}
	}
</style>